const ENVIRONMENT = {
  DEV: 'dev',
  UAT: 'uat',
  STAGING: 'staging',
  PROD: 'prod',
  INTERNET_DEV: 'internet-dev',
  INTERNET_PROD: 'internet-prod'
};

// eslint-disable-next-line import/prefer-default-export
export { ENVIRONMENT };
